export default __webpack_public_path__ + "static/desktop-bg-463eee10fecf80e55c30f13acf2399ac.mp4";